import React, { useContext, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import CloseIcon from "@mui/icons-material/Close";
import logo from "../../utils/images/success.png";
import { Context } from "../../../context/DataProvider";
import mailIcon from "../../utils/images/mailIcon.svg";
import { createPopup } from "@typeform/embed";
import "@typeform/embed/build/css/popup.css";
import { getCustomerSupportEmailId } from "../../../utils/constants";
import { Stack } from "@mui/material";

const delay = (ms) => new Promise((res) => setTimeout(res, ms));
export default function SuccessClaim(props) {
  const navigate = useNavigate();
  const { setBankSelected } = useContext(Context);
  const id = "FU54QexI";
  const widget = createPopup(id);

  const openFeedBackForm = async () => {
    await delay(300);
    widget.open();
  };

  const goTo = () => {
    navigate("/reimbursements");
    setBankSelected(null);
  };
  useEffect(() => {
    openFeedBackForm();
  });
  return (
    <Stack
      spacing={{ md: 2, sm: 1 }}
      direction="column"
      useFlexGap
      sx={{
        marginTop: "2rem", // default value for larger screens
        "@media (max-width:600px)": {
          marginTop: "6rem", // override for mobile screens
        },
      }}
    >
      <Stack direction={"row-reverse"}>
        <CloseIcon
          tabIndex="0"
          onClick={() => goTo()}
          onKeyDown={(e) => {
            if (e.key === "Enter" || e.key === " ") {
              e.preventDefault();
              goTo();
            }
          }}
          fontSize="large"
          sx={{ cursor: "pointer" }}
        />
      </Stack>
      <div>
        <img
          alt=""
          src={logo}
          style={{
            display: "block",
            marginLeft: "auto",
            marginRight: "auto",
            height: "300px",
            marginTop: "100px",
          }}
        />
        <br></br>
        {props.message === "resubmitted" ? (
          <p style={{ textAlign: "center", fontSize: "24px" }}>
            Your Claim {props.claimId} has been resubmitted successfully
          </p>
        ) : (
          <p style={{ textAlign: "center", fontSize: "24px" }}>
            Your Claim {props.claimId} has been successfully Raised
          </p>
        )}
      </div>

      <div className="successPageQueries">
        <div className="successPart1">
          <img src={mailIcon} alt="" />
          <b style={{ marginLeft: "10px" }}> Raise any claim related queries</b>
        </div>
        <div className="successPart2">
          <p>
            For speedy resolution to any doubts/concerns/queries related to your
            existing OPD claims, please write to our email id{" "}
            <strong>{getCustomerSupportEmailId()}</strong>. Our tech team will
            check at the earliest and get your issue resolved
          </p>
        </div>
      </div>
    </Stack>
  );
}
